import type { SkyVideoPlayerState } from '../Store'

export function getVisionChannelForDisplay(
  channelId: string,
  isRacingWA: boolean
): SkyVideoPlayerState['selectedChannel'] {
  return isRacingWA ? 'RacingWA' : channelId === 'SR1' ? 'Sky1' : 'Sky2'
}
